"use client";

import { FC, useEffect, useState } from "react";
import { A11y, Pagination, Navigation } from "swiper/modules";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { OfficeLocation } from "components/molecules/OfficeLocation/OfficeLocation";

import { OfficeLocationRecord } from "@graphql/types/graphql";
import s from "./OfficeLocationsCarousel.module.scss";
import Swiper from "swiper";

interface Props {
  officeLocations: OfficeLocationRecord[];
  activeLocation?: string;
}

export const OfficeLocationsCarousel: FC<Props> = ({ officeLocations, activeLocation }) => {
  const [swiper, setSwiper] = useState<Swiper>();

  useEffect(() => {
    if (activeLocation) {
      const index = officeLocations.findIndex((location) => location.slug === activeLocation);

      if (swiper && !swiper.destroyed && index !== -1) {
        swiper.slideTo(index);
      }
    }
  }, [activeLocation, officeLocations, swiper]);

  if (!officeLocations || officeLocations.length === 0) return null;

  return (
    <div className={s.Swiper}>
      <SwiperComponent
        spaceBetween={16}
        slidesPerView={1}
        slidesPerGroup={1}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        }}
        pagination={{ clickable: true }}
        breakpoints={{
          768: {
            spaceBetween: 24,
          },
        }}
        allowTouchMove={false}
        modules={[A11y, Pagination, Navigation]}
        style={{
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore - Swiper typings are not up to date
          "--swiper-navigation-color": "var(--color-blue)",
          "--swiper-navigation-size": "22px",
        }}
        onSwiper={setSwiper}
      >
        {officeLocations.map((location) => (
          <SwiperSlide className={s.Slide} key={location.id}>
            <div className={s.Location}>
              <h3 className={s.Title}>{location.title}</h3>
              <OfficeLocation location={location} key={location.id} />
            </div>
          </SwiperSlide>
        ))}
        <button type="button" className="swiper-button-prev" aria-label="Vorige slide" />
        <button type="button" className="swiper-button-next" aria-label="Volgende slide" />
      </SwiperComponent>
    </div>
  );
};
